import { render, staticRenderFns } from "./PlusCircle.vue?vue&type=template&id=d1887bba&"
import script from "./PlusCircle.vue?vue&type=script&setup=true&lang=js&"
export * from "./PlusCircle.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports